import { ProductFamilyList, ProductList } from "../constant/common.constant";

export const productNameToProductLineAndFamily = (productName: string) => {
  const productDefinition = ProductList.find(
    (product) => product.product.name === productName
  );
  const productFamily = ProductFamilyList.find(
    (family) => family.id === productDefinition?.family.name
  );
  return {
    productLine: productDefinition?.line,
    family: productFamily,
  };
};
